var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.796 3.638h.192V.646C11.987.208 11.774 0 11.332 0h-6.81c-.463 0-.67.205-.67.665l.001.767c0 .671.002 1.342-.004 2.012-.002.16.043.198.199.198a3135.01 3135.01 0 0 1 7.748-.004zm1.458 8.025V9.986c-.003-.306-.182-.48-.488-.487h-9.28c-.43 0-.582.151-.582.58v1.573l-.059.004c-.037.003-.07.006-.103.006h-.21c-.514.001-1.027.002-1.54 0-.614-.002-.992-.38-.992-.995V5.546c0-.621.381-1.007 1-1.007h13.998c.62 0 1.001.383 1.002 1.004v5.123c0 .615-.377.995-.99.997-.369.002-.738.001-1.107.001h-.649zm-5.182 2.991v.002h.364l1.118-.001a.834.834 0 0 0 .23-.024.441.441 0 0 0 .308-.484c-.03-.232-.215-.389-.487-.39a479.58 479.58 0 0 0-3.059.001.6.6 0 0 0-.226.046.44.44 0 0 0-.254.487c.037.203.21.36.43.361.374.004.749.003 1.123.003h.453zm.004-3.034H6.545c-.201-.002-.355.078-.443.26-.153.317.084.64.473.641 1.005.003 2.01.002 3.015 0 .306 0 .507-.182.507-.451 0-.27-.198-.449-.506-.45H8.076zm-4.271-1.212h8.541l.003.058c.003.04.005.077.005.114v4.498c0 .594-.324.916-.917.916H9.615c-1.632-.002-3.264-.004-4.896.006-.496.003-.927-.336-.92-.924.013-1.07.01-2.142.008-3.213l-.002-1.285v-.17z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default ForwardRef;